import React, {useMemo} from 'react';
import {useSuspenseQuery} from "@tanstack/react-query";
import {secretApi} from "../../../api/api";

export const UseSllTierRun = () => {
    const query = useSuspenseQuery(
        {
            queryKey: ['sllTierRune'],
            queryFn: async () => {
                const tier = await tier_run_first();

                return {tier}
            },
            staleTime: Infinity,
        })


    const data = useMemo(() => {
        if (!query?.data) {
            return {tier: {}}
        }
        return query.data
    }, [query.data])

    return {query, data};
}
const tier_run_first = async () => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/TierRunFirst`);
        const result = await secretApi.get(url.toString());




        return result?.data;
    } catch (e) {
        console.log(e)
        return {};
    }
}

export default UseSllTierRun;